var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "FormTitle",
        {
          staticClass: "pa-4 pt-0",
          attrs: { dark: "" },
          scopedSlots: _vm._u([
            {
              key: "subtitle",
              fn: function () {
                return [_vm._v("Register for upcoming events at Musicologie!")]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.program.title) + "\n        ")]
      ),
      _vm._v(" "),
      _c("FormItem", {
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v("Which location?")]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("SoliLocations", {
                  attrs: {
                    autocomplete: "",
                    hideDetails: "auto",
                    rules: _vm.rules_required,
                  },
                  model: {
                    value: _vm.form.location_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "location_id", $$v)
                    },
                    expression: "form.location_id",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v("Which event?")]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("v-select", {
                  attrs: {
                    items: _vm.program.group_events,
                    loading: _vm.apiEventsLoading,
                    rounded: "",
                    outlined: "",
                    dense: "",
                    "item-text": "title",
                    "item-value": "id",
                    label: _vm.form.group_event_id
                      ? _vm.program.title
                      : "Select an event",
                    "hide-details": "auto",
                    rules: _vm.rules_required,
                    menuProps: {
                      "max-width": 558,
                      "offset-y": true,
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: `item`,
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  { attrs: { "three-line": "" } },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-subtitle", [
                                          _vm._v(
                                            _vm._s(
                                              `Ages ${item.min_age}-${item.max_age}`
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.title)),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.form.group_event_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "group_event_id", $$v)
                    },
                    expression: "form.group_event_id",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v(_vm._s(`Which session?`))]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("v-select", {
                  attrs: {
                    items: _vm.apiEventRegisters,
                    loading: _vm.apiRegistersLoading,
                    "no-data-text":
                      "Sorry! No available sessions for this event",
                    rounded: "",
                    outlined: "",
                    dense: "",
                    "item-text": "dates",
                    "item-value": "id",
                    label: _vm.form.event_register_id
                      ? _vm.groupEvent?.title
                      : "Select a session",
                    "hide-details": "auto",
                    rules: [
                      (val) =>
                        !!_vm.form.location_id || "Please select a location",
                      (val) => val !== null || "This field is required",
                    ],
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: `item`,
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  { attrs: { "three-line": "" } },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.dates)),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _vm._v(_vm._s(item.time)),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _vm._v(
                                            _vm._s(`with ${item.teacher.name}`)
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.form.event_register_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "event_register_id", $$v)
                    },
                    expression: "form.event_register_id",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormSubmit", {
        attrs: {
          dark: "",
          type: "submit",
          loading: _vm.loading,
          valid: "",
          errors: _vm.errors,
          gradient: "gradient-orange",
          icon: "send",
          text: "Continue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }